import { render, staticRenderFns } from "./RequestViewTabHistory.vue?vue&type=template&id=f5c0e2e2"
import script from "./RequestViewTabHistory.vue?vue&type=script&lang=js"
export * from "./RequestViewTabHistory.vue?vue&type=script&lang=js"
import style0 from "./RequestViewTabHistory.vue?vue&type=style&index=0&id=f5c0e2e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports